































import Vue from 'vue'
export default Vue.extend({
  props: {
    label: {
      type: String,
      required: false,
    },
    minDate: {
      type: Date,
      required: false,
    },
    value: {
      type: String,
      required: false,
    },
    errors: {
      type: Array,
      required: false,
    },
  },
  name: 'DatePicker',
  methods: {
    save: function () {
      this.menu = false
      this.$emit('input', this.date)
    },
  },
  watch: {
    value: {
      immediate: true,
      deep: true,
      handler(val) {
        if (val) {
          this.date = val.substr(0, 10)
        }
      },
    },
  },
  data() {
    return {
      menu: false,
      date: this.value
        ? this.value.substr(0, 10)
        : new Date(Date.now() - new Date().getTimezoneOffset() * 60000)
            .toISOString()
            .substr(0, 10),
    }
  },
})
